import { css } from 'styled-components';
export const primaryShadow = () => css `
  box-shadow: 0 1px 6px 0 ${({ theme }) => theme.themeVariables.frameDropShadow};
`;
//# sourceMappingURL=primaryShadow.js.map